<template>
  <div class="content">
    <div class="info-box with-padding">
      <div class="info-hd">
        <h3>交易信息</h3>
      </div>
      <div class="info-bd">
        <div class="form">
          <div class="form-item">
            <label class="label">ICCID</label>
            <div class="element">
              <span id="wxTradeNum" class="txt-box">{{detailsData.iccid}}</span>
            </div>
          </div>
          <div class="form-item">
            <label class="label">微信支付订单号</label>
            <div class="element">
              <span id="mchTradeNo" class="txt-box">{{detailsData.orderNum}}</span>
            </div>
          </div>
          <div class="form-item">
            <label class="label">套餐名</label>
            <div class="element">
              <span id="mchTradeNo" class="txt-box">{{detailsData.productName}}</span>
            </div>
          </div>
          <div class="form-item">
            <label class="label">订单金额</label>
            <div class="element">
              <p class="txt-box">
                <span id="orderTotalAmount">{{detailsData.price}}</span><span class="gapl">元</span>
              </p>
            </div>
          </div>
          <div class="form-item">
            <label class="label">时间</label>
            <div class="element">
              <p class="txt-box">
                <span id="orderTotalAmount">{{detailsData.createtime}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-box with-padding">
      <div class="info-hd">
        <h3>套餐操作方式</h3>
      </div>
      <div class="info-bd">
        <div class="form">
          <div class="form-item">
            <label class="label">
              <span style="color: #e15f63;font-family: SimSun;">*</span>
                选择套餐操作方式
              </label>
            <div class="element">
              <el-radio v-model="mode" label="1" @change="switchs($event)" v-hasPermi="['package:operate:turn']">转套餐</el-radio>
              <el-radio v-model="mode" label="0" @change="switchs($event)" v-hasPermi="['package:operate:cancellation']">套餐作废</el-radio>
              <el-radio v-model="mode" label="2" @change="switchs($event)" v-hasPermi="['package:operate:updateTime']">更改套餐时间</el-radio>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-box with-padding">
      <div class="info-hd">
        <h3>套餐操作信息</h3>
      </div>
      <div class="info-bd">
        <div class="form">
          <div class="form-item" v-if="newtime">
            <label class="label">
              <span style="color: #e15f63;font-family: SimSun;">*</span>
              时间
            </label>
            <div class="element">
               <el-input v-model.trim="startTime" style="width: 274px;" placeholder="请输入开始时间"></el-input>
               <!-- <span> - </span>
               <el-input v-model="remark" style="width: 165px;" placeholder="请输入结束时间"></el-input> -->
            </div>
          </div>
          <div class="form-item" v-if="newIccid">
            <label class="label">
              <span style="color: #e15f63;font-family: SimSun;">*</span>
                新ICCID
            </label>
            <div class="element">
              <el-input v-model="transferIccid" placeholder="请输入新ICCID"></el-input>
            </div>
          </div>
          <div class="form-item" v-if="newexplain">
            <label class="label">
              <span style="color: #e15f63;font-family: SimSun;">*</span>
              说明
            </label>
            <div class="element">
               <el-input type="textarea" :rows="2" v-model="remark" style="width: 274px;" placeholder="请输入说明"></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-bottom: 50px;">
      <el-button type="primary" size="medium" @click="submitForm()">提交申请</el-button>
    </div>
  </div>
</template>
<script>
import { cardProductDetail } from "@/api/api.js"; //套餐的详情
import { orderTransferCardProduct } from "@/api/api.js";//套餐转移
import { orderInvalidCardProduct } from "@/api/api.js";//套餐作废
import { cardChangeCardProductTime } from "@/api/api.js";//修改套餐时间
export default {
  // name:'packageOperation',
  data() {
    return {
      newtime:false,
      newIccid:true,
      newexplain:true,

      mode: '1',
      transferIccid:'',
      remark:'',
      // 详情
      detailsData:{},
      startTime:"",
    };
  },
  methods: {
    // 获取列表的数据
    initData() {
      let params = {
        orderNum:this.$route.query && this.$route.query.orderNum
      }
      cardProductDetail(params).then(res=>{
        this.detailsData = res.data.data;
      })
    },
    // 切换套餐的操作方式
    switchs($event){
      if($event == 0){
        this.newtime = false;
        this.newIccid = false;
        this.newexplain = true;
      }else if($event == 1){
        this.newtime = false;
        this.newIccid = true;
        this.newexplain = true;
      }else{
        this.newtime = true;
        this.newIccid = false;
        this.newexplain = false;
      }
    },
    // 数据提交 
    submitForm(){
      if(this.mode == "1"){
        if(this.refundAmount == "" || this.remark == "")return this.$message.error("请输入新的iccid或说明");
        let params ={
          iccid:this.detailsData.iccid,
          orderNum:this.detailsData.orderNum,
          targetIccid:this.transferIccid,
          remark:this.remark
        };
        orderTransferCardProduct(params).then(res=>{
          if(res.data.code == 200){
            this.$notify({
              title: '成功',
              message: '转套餐成功',
              type: 'success',
              offset:30
            });
            setTimeout(()=>{
              this.$router.push({ path: `/package/packageManage` });
            },200)
          }else{
            this.$message.error(res.data.message);
          }
        })
      }else if(this.mode == "0"){
        if(this.remark == "")return this.$message.error("请输入说明");
        let params ={
          iccid:this.detailsData.iccid,
          orderNum:this.detailsData.orderNum,
          remark:this.remark
        };
        orderInvalidCardProduct(params).then(res=>{
          if(res.data.code == 200){
            this.$notify({
              title: '成功',
              message: '套餐作废成功',
              type: 'success',
              offset:30
            });
            setTimeout(()=>{
              this.$router.push({ path: `/package/packageManage` });
            },200)
          }
        })
      }else{
        if(this.startTime == "")return this.$message.error("请输入开始时间");
        let preams ={
          startTime:this.startTime,
          orderNum:this.detailsData.orderNum,
        }
        cardChangeCardProductTime(preams).then(res=>{
          if(res.data.code == 200){
            this.$notify({
              title: '成功',
              message: '修改套餐时间成功',
              type: 'success',
              offset:30
            });
            setTimeout(()=>{
              this.$router.push({ path: `/package/packageManage` });
            },200)
          }else{
            this.$message.error(res.data.message);
          }
        })
      }
    }
  },
  mounted() {
    this.initData();
  },
  created() {

  },
};
</script>
<style scoped lang="less">
.info-box {
  margin-bottom: 30px;
  border: 1px solid #EEE;
  width: 680px;
  font-size: 14px;
}
.info-box .info-hd {
  height: 38px;
  line-height: 38px;
  padding: 0 20px;
  background: #fafafa;
  border-bottom: 1px solid #EEE;
}
.info-box .info-bd {
  padding: 15px 40px;
  background: #FFFFFF;
}
.form-item {
  margin-bottom: 5px;
}
.form-item .label {
  float: left;
  width: 150px;
  padding-top: 9px;
  position: relative;
}
.form-item .element {
  margin-left: 100px;
  min-height: 42px;
  height: 42px;
  line-height: 42px;
}
.element .el-input{
  width: 274px;
}
</style>


